import React from "react";
import CONFIG from "../../../config";

import Dropzone from "../../../components/widgets/WidgetDropZone";
import File from "../../../components/widgets/WidgetFile";
import WidgetProgress from "../../../components/widgets/WidgetProgress";

import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CheckIcon from "@mui/icons-material/Check";
import Collapse from "@mui/material/Collapse";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import GroupDocument from "./GroupDocument";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Typography from "@mui/material/Typography";
import MetaGroupDocument from "./MetaGroupDocument";
import HomeIcon from "@mui/icons-material/Home";
import WorkIcon from "@mui/icons-material/Work";
import FolderIcon from "@mui/icons-material/Folder";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import SavingsIcon from "@mui/icons-material/Savings";
import FavoriteIcon from "@mui/icons-material/Favorite";
import PersonIcon from "@mui/icons-material/Person";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DocumentState from "./DocumentState";
import WidgetCheckbox from "../../../components/widgets/WidgetCheckbox";

function Dossier() {
  const navigate = useNavigate();
  const [collapse, setCollapse] = React.useState(null);
  const [user, setUser] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const [acceptCgu, setAcceptCgu] = React.useState(false);
  const [acceptRgpd, setAcceptRgpd] = React.useState(false);
  const [acceptCom, setAcceptCom] = React.useState(false);

  React.useEffect(() => {
    axios
      .get(CONFIG.API_URL + "/api/me", {
        headers: { Authorization: "Bearer " + localStorage.getItem("token") },
      })
      .then((response) => {
        switch (response.status) {
          case 200:
            setUser(response.data);
            break;
          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert(
            "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
          );
          return;
        }

        switch (response.status) {
          case 401:
            navigate("/connexion");
            break;
          default:
            alert(
              "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
            );
            break;
        }
      });
  }, []);

  return (
    <>
      {user !== null && (
        <>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Attention"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Ajout d'une visale :<br></br>
                <br></br>
                La garantie VISALE est un plus. Cependant, nous vous conseillons
                d'avoir également des garants physiques.
                <br></br>
                <br></br>
                Certaines agences prendront UNIQUEMENT les garants physiques,
                d'autres prendront UNIQUEMENT la garantie VISALE. Il est
                préférable d'avoir les deux afin d'obtenir le plus de
                propositions de logement possible.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} autoFocus>
                Ok
              </Button>
            </DialogActions>
          </Dialog>
          <div className="shrink-0 max-w-4xl mx-auto">
            <div className="m-6 grid grid-cols-12 gap-x-4 p-6 bg-white my-shadow">
              <div className="col-span-12 w-full mb-6 text-center">
                <h1>Mon dossier de relocation</h1>
              </div>
              <div className="col-span-12 w-full mb-4 text-center">
                <WidgetProgress
                  variant="determinate"
                  value={user.dossier.avancement_dossier * 100}
                />
              </div>
              <div className="col-span-12 w-full text-left font-semibold">
                {user.dossier.etat === "incomplet" && (
                  <>
                    Merci de compléter les éléments manquants en renseignant vos
                    informations personnelles et en fournissant les documents
                    demandés.
                    <br></br>
                    <br></br>
                    Une fois le dossier complet, n'oubliez pas de le soumettre
                    afin qu'il soit vérifié.
                  </>
                )}
                {user.dossier.etat === "complet" && (
                  <>
                    Votre dossier a bien été soumis à vérification. Un agent
                    Mouv'Immo le traitera sous 24h ouvrées, et vous fera un
                    retour. Vous serez alerté par email.
                  </>
                )}
                {(user.dossier.etat === "verifie" ||
                  user.dossier.etat === "propose") && (
                    <>
                      Votre dossier a bien été vérifié et validé. Un chargé de
                      relocation vous contactera sous 48h ouvrées afin de débuter
                      la recherche de logement.
                    </>
                  )}
                {user.dossier.etat === "attribue" && (
                  <>
                    Votre recherche de logement est en cours avec votre chargé
                    de relocation attitré.
                    <br></br>
                    <br></br>
                    Si besoin, vous pouvez nous contacter à l'adresse suivante
                    agence@mouv-immo.com .
                  </>
                )}
                {user.dossier.etat === "valide" && (
                  <>
                    Félicitations, votre recherche de logement avec Mouv'Immo
                    touche à sa fin.
                    <br></br>
                    <br></br>
                    Pour finaliser l'accompagnement, il ne vous manquera plus
                    qu'à :
                    <ul className="list-disc list-inside">
                      {user.dossier.type_facturation === 'Mobili-Pass' && (<li>
                        Signer électroniquement le dossier Mobili-Pass reçu par
                        mail
                      </li>)}
                      <li>
                        Nous transmettre votre bail signé par toutes les parties
                      </li>
                      {user.dossier.avancement_dossier !== 1 && (
                        <li>
                          Nous transmettre les documents manquants/rejetés
                          ci-dessous
                        </li>
                      )}
                    </ul>
                  </>
                )}
                {(user.dossier.etat === "envoye" ||
                  user.dossier.etat === "archive") && (
                    <>
                      Votre dossier a bien été soumis à vérification. Un agent
                      Mouv'Immo le traitera sous 24h ouvrées, et vous fera un
                      retour. Vous serez alerté par email.
                    </>
                  )}
              </div>
              <div className="col-span-12 w-full text-left text-red-600 font-bold">
                {user.dossier.etat === "incomplet" &&
                  user.dossier.type_contrat === "alternance" &&
                  user.dossier.list_garants.length === 0 && (
                    <>
                      <br></br>
                      En tant que personne en alternance, vous devez avoir un ou
                      des garants couvrant 3 fois le montant du loyer souhaité.
                    </>
                  )}
                {user.dossier.etat === "incomplet" &&
                  (user.dossier.list_garants.length === 0 ||
                    user.dossier.avancement_dossier !== 1) &&
                  user.dossier.type_contrat !== "alternance" &&
                  user.dossier.avancement_dossier_hors_garant === 1 && (
                    <>
                      <br></br>
                      Vous pouvez soumettre votre dossier sans garant, cependant
                      il est fortement conseillé d'en avoir, notamment dans le
                      cas d'un contrat avec période d'essai.
                    </>
                  )}
                {!["incomplet", "complet"].includes(user.dossier.etat) &&
                  user.dossier.avancement_dossier !== 1 && (
                    <>
                      <br></br>
                      Néanmoins, il manque quelques documents que vous pourrez
                      nous transmettre dès réception.
                    </>
                  )}

                {user.dossier.message !== "" && (
                  <>
                    <br></br>
                    <br></br>
                    <div className="col-span-12 w-full text-red-600 font-bold text-left">
                      {user.dossier.message}
                    </div>
                  </>
                )}
              </div>
              {user.dossier.etat === "incomplet" &&
                ((user.dossier.avancement_dossier === 1 &&
                  (user.dossier.type_contrat !== "alternance" ||
                    user.dossier.list_garants.length > 0)) ||
                  (user.dossier.type_contrat !== "alternance" &&
                    user.dossier.avancement_dossier_hors_garant === 1)) && (
                  <>
                    <div className="col-span-12 w-full mt-6 text-right">
                      <WidgetCheckbox
                        state={acceptCgu}
                        setState={setAcceptCgu}
                        id={"accept_cgu"}
                        text={"Je reconnais avoir lu les CGU"}
                      />
                    </div>
                    <div className="col-span-12 w-full text-right">
                      <WidgetCheckbox
                        state={acceptRgpd}
                        setState={setAcceptRgpd}
                        id={"accept_rgpd"}
                        text={
                          <>
                            <div className="text-left">
                              J'accepte la transmission de mes informations aux
                              partenaires de Mouv'Immo (agences immobilières,
                              particuliers, aide à l'installation, etc.) dans le
                              cadre de ma recherche de logement.
                            </div>
                          </>
                        }
                      />
                    </div>
                    <div className="col-span-12 w-full text-right hidden">
                      <WidgetCheckbox
                        state={acceptCom}
                        setState={setAcceptCom}
                        id={"accept_com"}
                        text={
                          "Je souhaite recevoir de la part de Mouv'Immo des propositions d'investissement commercial"
                        }
                      />
                    </div>
                  </>
                )}
              <div className="col-span-12 w-full mt-6 text-right">
                <Button
                  variant="contained"
                  disabled={
                    !(
                      user.dossier.etat === "incomplet" &&
                      ((user.dossier.avancement_dossier === 1 &&
                        (user.dossier.type_contrat !== "alternance" ||
                          user.dossier.list_garants.length > 0)) ||
                        (user.dossier.type_contrat !== "alternance" &&
                          user.dossier.avancement_dossier_hors_garant === 1))
                    )
                  }
                  onClick={() => {
                    if (!acceptCgu.value)
                      setAcceptCgu((s) => ({ ...s, error: true, errorMessage: "Vous devez accepter les CGU pour continuer." }));

                    if (!acceptRgpd.value)
                      setAcceptRgpd((s) => ({ ...s, error: true, errorMessage: "Vous devez accepter pour continuer." }));
                    
                    if (!acceptCgu.value || !acceptRgpd.value)
                      return;

                    axios
                      .post(
                        CONFIG.API_URL + "/api/client_soumettre_dossier",
                        {
                          accept_cgu: acceptCgu.value,
                          accept_rgpd: acceptRgpd.value,
                          accept_com: acceptCom.value,
                        },
                        {
                          headers: {
                            Authorization:
                              "Bearer " + localStorage.getItem("token"),
                          },
                        }
                      )
                      .then((response) => {
                        switch (response.status) {
                          case 200:
                            setUser(response.data);
                            break;

                          default:
                            break;
                        }
                      })
                      .catch((e) => {
                        let response = e.response;

                        if (response === undefined) {
                          alert(
                            "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
                          );
                          return;
                        }

                        switch (response.status) {
                          default:
                            alert(
                              "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
                            );
                            break;
                        }
                      });
                  }}
                >
                  {user.dossier.etat === "incomplet"
                    ? "Soumettre mon dossier"
                    : (user.dossier.etat === "attribue"
                      ? "Dossier en cours de recherche"
                      : "Dossier en cours de vérification")}
                </Button>
              </div>
            </div>

            <div className="divide-y m-6 grid grid-cols-12 gap-x-4 bg-white my-shadow">
              <div className="col-span-12 w-full grid grid-cols-12 gap-x-4 shrink-0">
                <div
                  className="col-span-12 grid grid-cols-12 p-6 hover:bg-gray-100 rounded-xl cursor-pointer"
                  onClick={() => setCollapse(!collapse)}
                >
                  <div className="flex col-span-8 w-full items-end">
                    <div className="pr-2 text-ame-gray">
                      <FormatListBulletedIcon fontSize="large"></FormatListBulletedIcon>
                    </div>
                    <div>
                      <h3>Informations personnelles</h3>
                    </div>
                  </div>

                  <DocumentState etat={user.dossier.questionnaire_etat} />
                </div>

                <div className="col-span-12 w-full px-6 shadow-inner shadow-gray-100">
                  <Collapse in={collapse}>
                    <hr className="mb-6"></hr>
                    <div className="col-span-12 w-full grid grid-cols-12 gap-4 pb-6">
                      <div className="col-span-10 w-full">
                        Nous avons besoin de ces informations pour établir la
                        liste des pièces justificatives nécessaires à votre
                        dossier.
                      </div>

                      <div className="col-span-2 w-full text-center flex flex-col justify-end">
                        <Button
                          variant={
                            user.dossier.questionnaire_etat === "manquant"
                              ? "contained"
                              : "outlined"
                          }
                          onClick={() => navigate("/client/questionnaire")}
                        >
                          {user.dossier.questionnaire_etat === "manquant"
                            ? "Répondre"
                            : "Consulter"}
                        </Button>
                      </div>
                    </div>
                  </Collapse>
                </div>
              </div>
            </div>

            <div className="divide-y m-6 grid grid-cols-12 gap-x-4 bg-white my-shadow">
              <MetaGroupDocument
                user={user}
                setUser={setUser}
                metaGroupIcon={<FolderIcon fontSize="large"></FolderIcon>}
                metaGroupName={"Documents locataire n°1"}
                groupList={[
                  {
                    groupIcon: <PersonIcon fontSize="large"></PersonIcon>,
                    groupName: "Personnel",
                    documentsList: (() => {
                      var result = [];

                      if (
                        user.dossier.documents.piece_identite
                          .obligatoire_cond ||
                        user.dossier.documents.piece_identite
                          .obligatoire_admin ||
                        user.dossier.documents.piece_identite.facultatif_cond
                      )
                        result.push({
                          titre: "Pièce d'identité",
                          description:
                            "Pièce d'identité recto verso à jour : carte ID, passeport ou titre de séjour.",
                          type_dossier: "dossier",
                          document_name: "piece_identite",
                          facultatif:
                            user.dossier.documents.piece_identite
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.piece_identite
                                .obligatoire_cond ||
                              user.dossier.documents.piece_identite
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.lettre_mission
                          .obligatoire_cond ||
                        user.dossier.documents.lettre_mission
                          .obligatoire_admin ||
                        user.dossier.documents.lettre_mission.facultatif_cond
                      )
                        result.push({
                          titre: "Mandat de recherche",
                          description: (
                            <>
                              Mandat de recherche (
                              <a
                                className="underline"
                                href={
                                  CONFIG.API_URL +
                                  "/api/lettre_mission/" +
                                  {
                                    "": 0,
                                    "Mobili-Pass": 0,
                                    "Agri Mobilité": 1,
                                    "Facturation directe particulier": 2,
                                    "Facturation directe entreprise": 3,
                                  }[user.dossier.type_facturation]
                                }
                              >
                                téléchargeable ici
                              </a>
                              ) à remplir et signer par l'entreprise.
                            </>
                          ),
                          type_dossier: "dossier",
                          document_name: "lettre_mission",
                          facultatif:
                            user.dossier.documents.lettre_mission
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.lettre_mission
                                .obligatoire_cond ||
                              user.dossier.documents.lettre_mission
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.accord_employeur
                          .obligatoire_cond ||
                        user.dossier.documents.accord_employeur
                          .obligatoire_admin ||
                        user.dossier.documents.accord_employeur.facultatif_cond
                      )
                        result.push({
                          titre: "Accord employeur",
                          description: (
                            <>
                              Document (
                              <a
                                className="underline"
                                href={
                                  CONFIG.API_URL +
                                  "/api/accord_employeur/" +
                                  {
                                    "": 0,
                                    "Mobili-Pass": 0,
                                    "Agri Mobilité": 1,
                                    "Facturation directe particulier": 0,
                                    "Facturation directe entreprise": 0,
                                  }[user.dossier.type_facturation]
                                }
                              >
                                téléchargeable ici
                              </a>
                              ) à faire remplir, signer et tamponner par votre
                              nouvelle entreprise.
                            </>
                          ),
                          type_dossier: "dossier",
                          document_name: "accord_employeur",
                          facultatif:
                            user.dossier.documents.accord_employeur
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.accord_employeur
                                .obligatoire_cond ||
                              user.dossier.documents.accord_employeur
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.attestation_separation
                          .obligatoire_cond ||
                        user.dossier.documents.attestation_separation
                          .obligatoire_admin ||
                        user.dossier.documents.attestation_separation
                          .facultatif_cond
                      )
                        result.push({
                          titre: "Attestation sur l'honneur de séparation",
                          description:
                            "Dans le cas d'un divorce pas encore prononcé et sans justificatif, les agences demandent une attestation de séparation sur papier libre.",
                          type_dossier: "dossier",
                          document_name: "attestation_separation",
                          facultatif:
                            user.dossier.documents.attestation_separation
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.attestation_separation
                                .obligatoire_cond ||
                              user.dossier.documents.attestation_separation
                                .obligatoire_admin
                            ),
                        });

                      return result;
                    })(),
                  },
                  {
                    groupIcon: <HomeIcon fontSize="large"></HomeIcon>,
                    groupName: "Justificatifs de domicile",
                    documentsList: (() => {
                      var result = [];

                      if (
                        user.dossier.documents.quittances_loyer
                          .obligatoire_cond ||
                        user.dossier.documents.quittances_loyer
                          .obligatoire_admin ||
                        user.dossier.documents.quittances_loyer.facultatif_cond
                      )
                        result.push({
                          titre: "3 Dernières quittance de loyer",
                          description:
                            "Reprenant les 3 derniers mois. Les avis d'échéance sont autorisés s'ils précisent un solde antérieur inférieur ou égal à 0€.",
                          type_dossier: "dossier",
                          document_name: "quittances_loyer",
                          facultatif:
                            user.dossier.documents.quittances_loyer
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.quittances_loyer
                                .obligatoire_cond ||
                              user.dossier.documents.quittances_loyer
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.taxe_fonciere.obligatoire_cond ||
                        user.dossier.documents.taxe_fonciere
                          .obligatoire_admin ||
                        user.dossier.documents.taxe_fonciere.facultatif_cond
                      )
                        result.push({
                          titre: "Taxe foncière recto-verso (N-1)",
                          description:
                            "Seulement l'année N-1 est prise en compte. Ce document est à retrouver sur votre espace impôts.gouv.",
                          type_dossier: "dossier",
                          document_name: "taxe_fonciere",
                          facultatif:
                            user.dossier.documents.taxe_fonciere
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.quittances_loyer
                                .obligatoire_cond ||
                              user.dossier.documents.quittances_loyer
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.facture_domicile
                          .obligatoire_cond ||
                        user.dossier.documents.facture_domicile
                          .obligatoire_admin ||
                        user.dossier.documents.facture_domicile.facultatif_cond
                      )
                        result.push({
                          titre: "Facture de moins d'un mois",
                          description:
                            "Factures acceptées : eau ou électricité ou gaz ou internet/téléphone. Les échéanciers ne sont pas pris en compte.",
                          type_dossier: "dossier",
                          document_name: "facture_domicile",
                          facultatif:
                            user.dossier.documents.facture_domicile
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.facture_domicile
                                .obligatoire_cond ||
                              user.dossier.documents.facture_domicile
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.attestation_hebergement
                          .obligatoire_cond ||
                        user.dossier.documents.attestation_hebergement
                          .obligatoire_admin ||
                        user.dossier.documents.attestation_hebergement
                          .facultatif_cond
                      )
                        result.push({
                          titre: "Attestation d'hébergement",
                          description: (
                            <>
                              Document (
                              <a
                                className="underline"
                                href={
                                  CONFIG.API_URL + "/api/accord_hebergement"
                                }
                              >
                                téléchargeable ici
                              </a>
                              ) à faire remplir par l'hébergeur.
                            </>
                          ),
                          type_dossier: "dossier",
                          document_name: "attestation_hebergement",
                          facultatif:
                            user.dossier.documents.attestation_hebergement
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.attestation_hebergement
                                .obligatoire_cond ||
                              user.dossier.documents.attestation_hebergement
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.carte_identite_hebergeur
                          .obligatoire_cond ||
                        user.dossier.documents.carte_identite_hebergeur
                          .obligatoire_admin ||
                        user.dossier.documents.carte_identite_hebergeur
                          .facultatif_cond
                      )
                        result.push({
                          titre: "Carte d'identitée de l'hébergeur",
                          description:
                            "Pièce d'identité recto verso à jour : carte ID, passeport ou titre de séjour de l'hébergeur.",
                          type_dossier: "dossier",
                          document_name: "carte_identite_hebergeur",
                          facultatif:
                            user.dossier.documents.carte_identite_hebergeur
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.carte_identite_hebergeur
                                .obligatoire_cond ||
                              user.dossier.documents.carte_identite_hebergeur
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.facture_domicile_hebergeur
                          .obligatoire_cond ||
                        user.dossier.documents.facture_domicile_hebergeur
                          .obligatoire_admin ||
                        user.dossier.documents.facture_domicile_hebergeur
                          .facultatif_cond
                      )
                        result.push({
                          titre: "Facture de l'hébergeur",
                          description:
                            "Factures acceptées : eau ou électricité ou gaz ou internet/téléphone. Les échéanciers ne sont pas pris en compte.",
                          type_dossier: "dossier",
                          document_name: "facture_domicile_hebergeur",
                          facultatif:
                            user.dossier.documents.facture_domicile_hebergeur
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.facture_domicile_hebergeur
                                .obligatoire_cond ||
                              user.dossier.documents.facture_domicile_hebergeur
                                .obligatoire_admin
                            ),
                        });

                      return result;
                    })(),
                  },
                  {
                    groupIcon: <WorkIcon fontSize="large"></WorkIcon>,
                    groupName: "Justificatifs de travail",
                    documentsList: (() => {
                      var result = [];

                      if (
                        user.dossier.documents.contrat_travail
                          .obligatoire_cond ||
                        user.dossier.documents.contrat_travail
                          .obligatoire_admin ||
                        user.dossier.documents.contrat_travail.facultatif_cond
                      )
                        result.push({
                          titre:
                            "Contrat de travail (ou attestation/promesse d'emploi de moins d'un mois)",
                          description:
                            "Signé par toutes les parties et tamponné par l'entreprise. Toutes les pages du contrat doivent figurer.",
                          type_dossier: "dossier",
                          document_name: "contrat_travail",
                          facultatif:
                            user.dossier.documents.contrat_travail
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.contrat_travail
                                .obligatoire_cond ||
                              user.dossier.documents.contrat_travail
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.certificat_signature_elec_contrat
                          .obligatoire_cond ||
                        user.dossier.documents.certificat_signature_elec_contrat
                          .obligatoire_admin ||
                        user.dossier.documents.certificat_signature_elec_contrat
                          .facultatif_cond
                      )
                        result.push({
                          titre:
                            "Certificat de signature électronique du contrat de travail",
                          description:
                            "Si le contrat a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                          type_dossier: "dossier",
                          document_name: "certificat_signature_elec_contrat",
                          facultatif:
                            user.dossier.documents
                              .certificat_signature_elec_contrat
                              .facultatif_cond &&
                            !(
                              user.dossier.documents
                                .certificat_signature_elec_contrat
                                .obligatoire_cond ||
                              user.dossier.documents
                                .certificat_signature_elec_contrat
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.avis_mutation.obligatoire_cond ||
                        user.dossier.documents.avis_mutation
                          .obligatoire_admin ||
                        user.dossier.documents.avis_mutation.facultatif_cond
                      )
                        result.push({
                          titre: "Avenant ou avis de mutation",
                          description: "Signé et tamponné par l'entreprise.",
                          type_dossier: "dossier",
                          document_name: "avis_mutation",
                          facultatif:
                            user.dossier.documents.avis_mutation
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.avis_mutation
                                .obligatoire_cond ||
                              user.dossier.documents.avis_mutation
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents
                          .certificat_signature_elec_mutation
                          .obligatoire_cond ||
                        user.dossier.documents
                          .certificat_signature_elec_mutation
                          .obligatoire_admin ||
                        user.dossier.documents
                          .certificat_signature_elec_mutation.facultatif_cond
                      )
                        result.push({
                          titre:
                            "Certificat de signature de l'avenant ou de l'avis de mutation",
                          description:
                            "Si le document a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                          type_dossier: "dossier",
                          document_name: "certificat_signature_elec_mutation",
                          facultatif:
                            user.dossier.documents
                              .certificat_signature_elec_mutation
                              .facultatif_cond &&
                            !(
                              user.dossier.documents
                                .certificat_signature_elec_mutation
                                .obligatoire_cond ||
                              user.dossier.documents
                                .certificat_signature_elec_mutation
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.contrat_apprentissage
                          .obligatoire_cond ||
                        user.dossier.documents.contrat_apprentissage
                          .obligatoire_admin ||
                        user.dossier.documents.contrat_apprentissage
                          .facultatif_cond
                      )
                        result.push({
                          titre:
                            "Contrat d'alternance (ou attestation/promesse d'emploi de moins d'un mois)",
                          description:
                            "Signé par toutes les parties et tamponné par l'entreprise. Les deux pages du contrat doivent figurer.",
                          type_dossier: "dossier",
                          document_name: "contrat_apprentissage",
                          facultatif:
                            user.dossier.documents.contrat_apprentissage
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.contrat_apprentissage
                                .obligatoire_cond ||
                              user.dossier.documents.contrat_apprentissage
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.certificat_scolarite
                          .obligatoire_cond ||
                        user.dossier.documents.certificat_scolarite
                          .obligatoire_admin ||
                        user.dossier.documents.certificat_scolarite
                          .facultatif_cond
                      )
                        result.push({
                          titre: "Carte étudiante ou attestation de formation",
                          description:
                            "Correspondant à l'année du contrat d'alternance + l'attestation ou carte étudiante actuelle si l'année étudiante en cours n'est pas terminée.",
                          type_dossier: "dossier",
                          document_name: "certificat_scolarite",
                          facultatif:
                            user.dossier.documents.certificat_scolarite
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.certificat_scolarite
                                .obligatoire_cond ||
                              user.dossier.documents.certificat_scolarite
                                .obligatoire_admin
                            ),
                        });

                      return result;
                    })(),
                  },
                  {
                    groupIcon: <SavingsIcon fontSize="large"></SavingsIcon>,
                    groupName: "Impôts et revenus",
                    documentsList: (() => {
                      var result = [];

                      if (
                        user.dossier.documents.avis_imposition
                          .obligatoire_cond ||
                        user.dossier.documents.avis_imposition
                          .obligatoire_admin ||
                        user.dossier.documents.avis_imposition.facultatif_cond
                      )
                        result.push({
                          titre:
                            "Deux derniers avis d'imposition (N-1 et N-2) avec toutes les pages ou l'ASDIR",
                          description:
                            "Si rattaché fiscalement, merci de fournir les avis des parents. Pour les personnes non imposables, l'ASDIR (anciennement avis de non-imposition). Pour les ressortissants étrangers, le justificatif fiscal du pays d'origine traduit en français et converti en euros.",
                          type_dossier: "dossier",
                          document_name: "avis_imposition",
                          facultatif:
                            user.dossier.documents.avis_imposition
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.avis_imposition
                                .obligatoire_cond ||
                              user.dossier.documents.avis_imposition
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.attestation_ratachement
                          .obligatoire_cond ||
                        user.dossier.documents.attestation_ratachement
                          .obligatoire_admin ||
                        user.dossier.documents.attestation_ratachement
                          .facultatif_cond
                      )
                        result.push({
                          titre: "Attestation de rattachement fiscal",
                          description: (
                            <>
                              (
                              <a
                                className="underline"
                                href={
                                  CONFIG.API_URL +
                                  "/api/attestation_rattachement"
                                }
                              >
                                Téléchargeable ici
                              </a>
                              ). Si rattaché sur les deux derniers avis, merci
                              d'indiquer les 2 années d'imposition (et non les
                              années de réception de l'avis).
                            </>
                          ),
                          type_dossier: "dossier",
                          document_name: "attestation_ratachement",
                          facultatif:
                            user.dossier.documents.attestation_ratachement
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.attestation_ratachement
                                .obligatoire_cond ||
                              user.dossier.documents.attestation_ratachement
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.carte_identite_ratacheur
                          .obligatoire_cond ||
                        user.dossier.documents.carte_identite_ratacheur
                          .obligatoire_admin ||
                        user.dossier.documents.carte_identite_ratacheur
                          .facultatif_cond
                      )
                        result.push({
                          titre: "Carte d'identité du/des parents",
                          description:
                            "Si rattaché, merci de fournir la carte ID recto-verso des personnes titulaires de l'avis d'imposition.",
                          type_dossier: "dossier",
                          document_name: "carte_identite_ratacheur",
                          facultatif:
                            user.dossier.documents.carte_identite_ratacheur
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.carte_identite_ratacheur
                                .obligatoire_cond ||
                              user.dossier.documents.carte_identite_ratacheur
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.bultins_salaire
                          .obligatoire_cond ||
                        user.dossier.documents.bultins_salaire
                          .obligatoire_admin ||
                        user.dossier.documents.bultins_salaire.facultatif_cond
                      )
                        result.push({
                          titre: "3 derniers bulletins de salaire",
                          description:
                            "Si document en plusieurs pages, toutes les pages doivent figurer.",
                          type_dossier: "dossier",
                          document_name: "bultins_salaire",
                          facultatif:
                            user.dossier.documents.bultins_salaire
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.bultins_salaire
                                .obligatoire_cond ||
                              user.dossier.documents.bultins_salaire
                                .obligatoire_admin
                            ),
                        });

                      if (
                        user.dossier.documents.livret_famille
                          .obligatoire_cond ||
                        user.dossier.documents.livret_famille
                          .obligatoire_admin ||
                        user.dossier.documents.livret_famille.facultatif_cond
                      )
                        result.push({
                          titre: "Livret de famille",
                          description:
                            "L'organisme nous demande ce document afin de prouver le rattachement fiscal ou les enfants à charge. Cf liste des documents Mobili-Pass sur le site Action Logement.",
                          type_dossier: "dossier",
                          document_name: "livret_famille",
                          facultatif:
                            user.dossier.documents.livret_famille
                              .facultatif_cond &&
                            !(
                              user.dossier.documents.livret_famille
                                .obligatoire_cond ||
                              user.dossier.documents.livret_famille
                                .obligatoire_admin
                            ),
                        });

                      return result;
                    })(),
                  },
                  {
                    groupIcon: <AddBoxIcon fontSize="large"></AddBoxIcon>,
                    groupName: "Dépôt libre",
                    documentsList: (() => {
                      var result = [];

                      result.push({
                        titre: "Dépôt libre",
                        description: "",
                        type_dossier: "dossier",
                        document_name: "depot_libre",
                        facultatif: true,
                      });

                      return result;
                    })(),
                  },
                ]}
              />
            </div>
            <hr className="w-full border-gray-400"></hr>

            <div className="divide-y m-6 flex gap-x-4 px-6">
              <div className="flex-1">
                <Button
                  variant="contained"
                  className="w-full"
                  disabled={user.dossier.avec_deuxieme_locataire}
                  onClick={() => {
                    axios
                      .post(
                        CONFIG.API_URL + "/api/client_add_locataire",
                        {},
                        {
                          headers: {
                            Authorization:
                              "Bearer " + localStorage.getItem("token"),
                          },
                        }
                      )
                      .then((response) => {
                        switch (response.status) {
                          case 200:
                            navigate("/client/questionnaire_locataire/0");
                            setUser(response.data);
                            break;

                          default:
                            break;
                        }
                      })
                      .catch((e) => {
                        let response = e.response;

                        if (response === undefined) {
                          alert(
                            "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
                          );
                          return;
                        }

                        switch (response.status) {
                          default:
                            alert(
                              "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
                            );
                            break;
                        }
                      });
                  }}
                >
                  Ajouter un 2ème locataire
                </Button>
              </div>
              <div className="flex-1">
                <Button
                  variant="contained"
                  className="w-full"
                  onClick={() => {
                    axios
                      .post(
                        CONFIG.API_URL + "/api/client_add_garant",
                        {},
                        {
                          headers: {
                            Authorization:
                              "Bearer " + localStorage.getItem("token"),
                          },
                        }
                      )
                      .then((response) => {
                        switch (response.status) {
                          case 200:
                            navigate(
                              "/client/questionnaire_garant/" +
                              (response.data.dossier.list_garants.length - 1)
                            );
                            setUser(response.data);
                            break;

                          default:
                            break;
                        }
                      })
                      .catch((e) => {
                        let response = e.response;

                        if (response === undefined) {
                          alert(
                            "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
                          );
                          return;
                        }

                        switch (response.status) {
                          default:
                            alert(
                              "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
                            );
                            break;
                        }
                      });
                  }}
                >
                  Ajouter un garant
                </Button>
              </div>
              <div className="flex-1">
                <Button
                  variant="contained"
                  className="w-full"
                  disabled={
                    user.dossier.type_contrat === "alternance" ||
                    user.dossier.avec_visale
                  }
                  onClick={() => {
                    axios
                      .post(
                        CONFIG.API_URL + "/api/client_add_visale",
                        {},
                        {
                          headers: {
                            Authorization:
                              "Bearer " + localStorage.getItem("token"),
                          },
                        }
                      )
                      .then((response) => {
                        switch (response.status) {
                          case 200:
                            setOpen(true);
                            setUser(response.data);
                            break;

                          default:
                            break;
                        }
                      })
                      .catch((e) => {
                        let response = e.response;

                        if (response === undefined) {
                          alert(
                            "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
                          );
                          return;
                        }

                        switch (response.status) {
                          default:
                            alert(
                              "Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement."
                            );
                            break;
                        }
                      });
                  }}
                >
                  Ajouter une garantie visale
                </Button>
              </div>
            </div>

            {user.dossier.avec_deuxieme_locataire && (
              <div className="divide-y m-6 grid grid-cols-12 gap-x-4 bg-white my-shadow">
                <MetaGroupDocument
                  user={user}
                  setUser={setUser}
                  metaGroupIcon={<FolderIcon fontSize="large"></FolderIcon>}
                  metaGroupName={"Documents locataire n°2"}
                  grantLocataire={"deuxieme_locataire"}
                  commentary={user.dossier.deuxieme_locataire.message}
                  groupList={[
                    {
                      groupIcon: <PersonIcon fontSize="large"></PersonIcon>,
                      groupName: "Personnel",
                      documentsList: (() => {
                        var result = [];

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .piece_identite.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .piece_identite.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .piece_identite.facultatif_cond
                        )
                          result.push({
                            titre: "Pièce d'identité",
                            description:
                              "Pièce d'identité recto verso à jour : carte ID, passeport ou titre de séjour.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "piece_identite",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .piece_identite.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .piece_identite.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .piece_identite.obligatoire_admin
                              ),
                          });

                        return result;
                      })(),
                    },
                    {
                      groupIcon: <HomeIcon fontSize="large"></HomeIcon>,
                      groupName: "Justificatifs de domicile",
                      documentsList: (() => {
                        var result = [];

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .quittances_loyer.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .quittances_loyer.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .quittances_loyer.facultatif_cond
                        )
                          result.push({
                            titre: "3 Dernières quittance de loyer",
                            description:
                              "Reprenant les 3 derniers mois. Les avis d'échéance sont autorisés s'ils précisent un solde antérieur inférieur ou égal à 0€.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "quittances_loyer",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .quittances_loyer.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .quittances_loyer.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .quittances_loyer.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .taxe_fonciere.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .taxe_fonciere.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .taxe_fonciere.facultatif_cond
                        )
                          result.push({
                            titre: "Taxe foncière recto-verso (N-1)",
                            description:
                              "Seulement l'année N-1 est prise en compte. Ce document est à retrouver sur votre espace impôts.gouv.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "taxe_fonciere",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .taxe_fonciere.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .taxe_fonciere.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .taxe_fonciere.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .facture_domicile.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .facture_domicile.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .facture_domicile.facultatif_cond
                        )
                          result.push({
                            titre: "Facture de moins d'un mois",
                            description:
                              "Factures acceptées : eau ou électricité ou gaz ou internet/téléphone. Les échéanciers ne sont pas pris en compte.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "facture_domicile",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .facture_domicile.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .facture_domicile.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .facture_domicile.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .attestation_hebergement.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .attestation_hebergement.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .attestation_hebergement.facultatif_cond
                        )
                          result.push({
                            titre: "Attestation d'hébergement",
                            description: (
                              <>
                                Document (
                                <a
                                  className="underline"
                                  href={
                                    CONFIG.API_URL + "/api/accord_hebergement"
                                  }
                                >
                                  téléchargeable ici
                                </a>
                                ) à faire remplir par l'hébergeur.
                              </>
                            ),
                            type_dossier: "deuxieme_locataire",
                            document_name: "attestation_hebergement",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .attestation_hebergement.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .attestation_hebergement.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .attestation_hebergement.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .carte_identite_hebergeur.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .carte_identite_hebergeur.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .carte_identite_hebergeur.facultatif_cond
                        )
                          result.push({
                            titre: "Carte d'identitée de l'hébergeur",
                            description:
                              "Pièce d'identité recto verso à jour : carte ID, passeport ou titre de séjour de l'hébergeur.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "carte_identite_hebergeur",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .carte_identite_hebergeur.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .carte_identite_hebergeur.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .carte_identite_hebergeur.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .facture_domicile_hebergeur.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .facture_domicile_hebergeur.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .facture_domicile_hebergeur.facultatif_cond
                        )
                          result.push({
                            titre: "Facture de l'hébergeur",
                            description:
                              "Factures acceptées : eau ou électricité ou gaz ou internet/téléphone. Les échéanciers ne sont pas pris en compte.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "facture_domicile_hebergeur",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .facture_domicile_hebergeur.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .facture_domicile_hebergeur
                                  .obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .facture_domicile_hebergeur.obligatoire_admin
                              ),
                          });

                        return result;
                      })(),
                    },
                    {
                      groupIcon: <WorkIcon fontSize="large"></WorkIcon>,
                      groupName: "Justificatifs de travail",
                      documentsList: (() => {
                        var result = [];

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .contrat_travail.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .contrat_travail.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .contrat_travail.facultatif_cond
                        )
                          result.push({
                            titre:
                              "Contrat de travail (ou attestation/promesse d'emploi de moins d'un mois)",
                            description:
                              "Signé par toutes les parties et tamponné par l'entreprise. Toutes les pages du contrat doivent figurer.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "contrat_travail",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .contrat_travail.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .contrat_travail.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .contrat_travail.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .certificat_signature_elec_contrat
                            .obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .certificat_signature_elec_contrat
                            .obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .certificat_signature_elec_contrat.facultatif_cond
                        )
                          result.push({
                            titre:
                              "Certificat de signature électronique du contrat de travail",
                            description:
                              "Si le contrat a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "certificat_signature_elec_contrat",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .certificat_signature_elec_contrat
                                .facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .certificat_signature_elec_contrat
                                  .obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .certificat_signature_elec_contrat
                                  .obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .arrete_titularisation.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .arrete_titularisation.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .arrete_titularisation.facultatif_cond
                        )
                          result.push({
                            titre:
                              "Attestation employeur ou arrêté de titularisation",
                            description:
                              "Si attestation, elle doit dater de moins d'un mois",
                            type_dossier: "deuxieme_locataire",
                            document_name: "arrete_titularisation",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .arrete_titularisation.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .arrete_titularisation.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .arrete_titularisation.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .bilans_comptable.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .bilans_comptable.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .bilans_comptable.facultatif_cond
                        )
                          result.push({
                            titre: "2 Derniers bilans comptables",
                            description:
                              "Bilans des années N-1 et N-2 reprenant le chiffre d'affaires et le résultat.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "bilans_comptable",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .bilans_comptable.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .bilans_comptable.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .bilans_comptable.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents.k_bis
                            .obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents.k_bis
                            .obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents.k_bis
                            .facultatif_cond
                        )
                          result.push({
                            titre: "Extrait K-Bis",
                            description:
                              "L'extrait doit dater de moins de 3 mois.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "k_bis",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents.k_bis
                                .facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents.k_bis
                                  .obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents.k_bis
                                  .obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .declaration_urssaf.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .declaration_urssaf.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .declaration_urssaf.facultatif_cond
                        )
                          result.push({
                            titre: "Déclarations URSSAF",
                            description:
                              "Pour les auto-entrepreneurs, les déclarations URSSAF reprenant le chiffre d'affaire des 2 dernières années.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "declaration_urssaf",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .declaration_urssaf.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .declaration_urssaf.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .declaration_urssaf.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .carte_professionnelle.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .carte_professionnelle.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .carte_professionnelle.facultatif_cond
                        )
                          result.push({
                            titre: "Carte professionnelle",
                            description: "Pour les professions réglementées.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "carte_professionnelle",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .carte_professionnelle.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .carte_professionnelle.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .carte_professionnelle.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .attestation_salaire.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .attestation_salaire.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .attestation_salaire.facultatif_cond
                        )
                          result.push({
                            titre: "Attestation de salaire",
                            description:
                              "S'il y a un versement de salaire, l'attestation comptable reprenant le montant.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "attestation_salaire",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .attestation_salaire.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .attestation_salaire.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .attestation_salaire.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .justificatifs_paiements_retraite
                            .obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .justificatifs_paiements_retraite
                            .obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .justificatifs_paiements_retraite.facultatif_cond
                        )
                          result.push({
                            titre:
                              "3 Derniers justificatifs de paiement de(s) caisse(s) de retraite",
                            description:
                              "Les relevés des 3 derniers mois pour chaque caisse. Les preuves de versement ou relevés bancaires ne sont pas pris en compte.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "justificatifs_paiements_retraite",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .justificatifs_paiements_retraite
                                .facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .justificatifs_paiements_retraite
                                  .obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .justificatifs_paiements_retraite
                                  .obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .ouverture_droit.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .ouverture_droit.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .ouverture_droit.facultatif_cond
                        )
                          result.push({
                            titre: "Document d'ouverture de droit",
                            description:
                              "Le document reprenant les droits pour chaque caisse de retraite.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "ouverture_droit",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .ouverture_droit.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .ouverture_droit.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .ouverture_droit.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .releves_paiement.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .releves_paiement.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .releves_paiement.facultatif_cond
                        )
                          result.push({
                            titre:
                              "3 derniers relevés de versement Pôle Emploi",
                            description:
                              "Documents des 3 derniers mois. Les relevés bancaires ne sont pas pris en compte.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "releves_paiement",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .releves_paiement.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .releves_paiement.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .releves_paiement.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .certificat_scolarite.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .certificat_scolarite.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .certificat_scolarite.facultatif_cond
                        )
                          result.push({
                            titre:
                              "Carte étudiante ou attestation de formation",
                            description:
                              "Attestation ou carte étudiante actuelle si l'année étudiante en cours n'est pas terminée.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "certificat_scolarite",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .certificat_scolarite.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .certificat_scolarite.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .certificat_scolarite.obligatoire_admin
                              ),
                          });

                        return result;
                      })(),
                    },
                    {
                      groupIcon: <SavingsIcon fontSize="large"></SavingsIcon>,
                      groupName: "Impôts et revenus",
                      documentsList: (() => {
                        var result = [];

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .avis_imposition.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .avis_imposition.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .avis_imposition.facultatif_cond
                        )
                          result.push({
                            titre:
                              "Deux derniers avis d'imposition (N-1 et N-2) avec toutes les pages ou l'ASDIR",
                            description:
                              "Si rattaché fiscalement, merci de fournir les avis des parents. Pour les personnes non imposables, l'ASDIR (anciennement avis de non-imposition). Pour les ressortissants étrangers, le justificatif fiscal du pays d'origine traduit en français et converti en euros.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "avis_imposition",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .avis_imposition.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .avis_imposition.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .avis_imposition.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .attestation_ratachement.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .attestation_ratachement.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .attestation_ratachement.facultatif_cond
                        )
                          result.push({
                            titre: "Attestation de rattachement fiscal",
                            description: (
                              <>
                                (
                                <a
                                  className="underline"
                                  href={
                                    CONFIG.API_URL +
                                    "/api/attestation_rattachement"
                                  }
                                >
                                  Téléchargeable ici
                                </a>
                                ). Si rattaché sur les deux derniers avis, merci
                                d'indiquer les 2 années d'imposition (et non les
                                années de réception de l'avis).
                              </>
                            ),
                            type_dossier: "deuxieme_locataire",
                            document_name: "attestation_ratachement",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .attestation_ratachement.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .attestation_ratachement.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .attestation_ratachement.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .carte_identite_ratacheur.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .carte_identite_ratacheur.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .carte_identite_ratacheur.facultatif_cond
                        )
                          result.push({
                            titre: "Carte d'identité du/des parents",
                            description:
                              "Si rattaché, merci de fournir la carte ID recto-verso des personnes titulaires de l'avis d'imposition.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "carte_identite_ratacheur",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .carte_identite_ratacheur.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .carte_identite_ratacheur.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .carte_identite_ratacheur.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .bultins_salaire.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .bultins_salaire.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .bultins_salaire.facultatif_cond
                        )
                          result.push({
                            titre: "3 derniers bulletins de salaire",
                            description:
                              "Si document en plusieurs pages, toutes les pages doivent figurer.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "bultins_salaire",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .bultins_salaire.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .bultins_salaire.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .bultins_salaire.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .livret_famille.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .livret_famille.obligatoire_admin ||
                          user.dossier.deuxieme_locataire.documents
                            .livret_famille.facultatif_cond
                        )
                          result.push({
                            titre: "Livret de famille",
                            description:
                              "L'organisme nous demande ce document afin de prouver le rattachement fiscal ou les enfants à charge. Cf liste des documents Mobili-Pass sur le site Action Logement.",
                            type_dossier: "deuxieme_locataire",
                            document_name: "livret_famille",
                            facultatif:
                              user.dossier.deuxieme_locataire.documents
                                .livret_famille.facultatif_cond &&
                              !(
                                user.dossier.deuxieme_locataire.documents
                                  .livret_famille.obligatoire_cond ||
                                user.dossier.deuxieme_locataire.documents
                                  .livret_famille.obligatoire_admin
                              ),
                          });

                        return result;
                      })(),
                    },
                    {
                      groupIcon: <AddBoxIcon fontSize="large"></AddBoxIcon>,
                      groupName: "Dépôt libre",
                      documentsList: (() => {
                        var result = [];

                        result.push({
                          titre: "Dépôt libre",
                          description: "",
                          type_dossier: "deuxieme_locataire",
                          document_name: "depot_libre",
                          facultatif: true,
                        });

                        return result;
                      })(),
                    },
                  ]}
                />
              </div>
            )}

            {user.dossier.list_garants.map((garant, id) => (
              <div
                key={id}
                className="divide-y m-6 grid grid-cols-12 gap-x-4 bg-white my-shadow"
              >
                <MetaGroupDocument
                  user={user}
                  setUser={setUser}
                  metaGroupIcon={<FolderIcon fontSize="large"></FolderIcon>}
                  metaGroupName={"Documents garant n°" + (id + 1)}
                  grantLocataire={id}
                  commentary={user.dossier.list_garants[id].message}
                  groupList={[
                    {
                      groupIcon: <PersonIcon fontSize="large"></PersonIcon>,
                      groupName: "Personnel",
                      documentsList: (() => {
                        var result = [];

                        if (
                          user.dossier.list_garants[id].documents.piece_identite
                            .obligatoire_cond ||
                          user.dossier.list_garants[id].documents.piece_identite
                            .obligatoire_admin ||
                          user.dossier.list_garants[id].documents.piece_identite
                            .facultatif_cond
                        )
                          result.push({
                            titre: "Pièce d'identité",
                            description:
                              "Pièce d'identité recto verso à jour : carte ID, passeport ou titre de séjour.",
                            type_dossier: id,
                            document_name: "piece_identite",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .piece_identite.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .piece_identite.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .piece_identite.obligatoire_admin
                              ),
                          });

                        return result;
                      })(),
                    },
                    {
                      groupIcon: <HomeIcon fontSize="large"></HomeIcon>,
                      groupName: "Justificatifs de domicile",
                      documentsList: (() => {
                        var result = [];

                        if (
                          user.dossier.list_garants[id].documents
                            .quittances_loyer.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .quittances_loyer.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .quittances_loyer.facultatif_cond
                        )
                          result.push({
                            titre: "3 Dernières quittance de loyer",
                            description:
                              "Reprenant les 3 derniers mois. Les avis d'échéance sont autorisés s'ils précisent un solde antérieur inférieur ou égal à 0€.",
                            type_dossier: id,
                            document_name: "quittances_loyer",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .quittances_loyer.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .quittances_loyer.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .quittances_loyer.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents.taxe_fonciere
                            .obligatoire_cond ||
                          user.dossier.list_garants[id].documents.taxe_fonciere
                            .obligatoire_admin ||
                          user.dossier.list_garants[id].documents.taxe_fonciere
                            .facultatif_cond
                        )
                          result.push({
                            titre: "Taxe foncière recto-verso (N-1)",
                            description:
                              "Seulement l'année N-1 est prise en compte. Ce document est à retrouver sur votre espace impôts.gouv.",
                            type_dossier: id,
                            document_name: "taxe_fonciere",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .taxe_fonciere.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .taxe_fonciere.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .taxe_fonciere.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .facture_domicile.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .facture_domicile.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .facture_domicile.facultatif_cond
                        )
                          result.push({
                            titre: "Facture de moins d'un mois",
                            description:
                              "Factures acceptées : eau ou électricité ou gaz ou internet/téléphone. Les échéanciers ne sont pas pris en compte.",
                            type_dossier: id,
                            document_name: "facture_domicile",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .facture_domicile.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .facture_domicile.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .facture_domicile.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .attestation_hebergement.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .attestation_hebergement.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .attestation_hebergement.facultatif_cond
                        )
                          result.push({
                            titre: "Attestation d'hébergement",
                            description: (
                              <>
                                Document (
                                <a
                                  className="underline"
                                  href={
                                    CONFIG.API_URL + "/api/accord_hebergement"
                                  }
                                >
                                  téléchargeable ici
                                </a>
                                ) à faire remplir par l'hébergeur.
                              </>
                            ),
                            type_dossier: id,
                            document_name: "attestation_hebergement",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .attestation_hebergement.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .attestation_hebergement.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .attestation_hebergement.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .carte_identite_hebergeur.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .carte_identite_hebergeur.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .carte_identite_hebergeur.facultatif_cond
                        )
                          result.push({
                            titre: "Carte d'identitée de l'hébergeur",
                            description:
                              "Pièce d'identité recto verso à jour : carte ID, passeport ou titre de séjour de l'hébergeur.",
                            type_dossier: id,
                            document_name: "carte_identite_hebergeur",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .carte_identite_hebergeur.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .carte_identite_hebergeur.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .carte_identite_hebergeur.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .facture_domicile_hebergeur.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .facture_domicile_hebergeur.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .facture_domicile_hebergeur.facultatif_cond
                        )
                          result.push({
                            titre: "Facture de l'hébergeur",
                            description:
                              "Factures acceptées : eau ou électricité ou gaz ou internet/téléphone. Les échéanciers ne sont pas pris en compte.",
                            type_dossier: id,
                            document_name: "facture_domicile_hebergeur",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .facture_domicile_hebergeur.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .facture_domicile_hebergeur
                                  .obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .facture_domicile_hebergeur.obligatoire_admin
                              ),
                          });

                        return result;
                      })(),
                    },
                    {
                      groupIcon: <WorkIcon fontSize="large"></WorkIcon>,
                      groupName: "Justificatifs de travail",
                      documentsList: (() => {
                        var result = [];

                        if (
                          user.dossier.list_garants[id].documents
                            .contrat_travail.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .contrat_travail.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .contrat_travail.facultatif_cond
                        )
                          result.push({
                            titre:
                              "Contrat de travail (ou attestation/promesse d'emploi de moins d'un mois)",
                            description:
                              "Signé par toutes les parties et tamponné par l'entreprise. Toutes les pages du contrat doivent figurer.",
                            type_dossier: id,
                            document_name: "contrat_travail",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .contrat_travail.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .contrat_travail.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .contrat_travail.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .certificat_signature_elec_contrat
                            .obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .certificat_signature_elec_contrat
                            .obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .certificat_signature_elec_contrat.facultatif_cond
                        )
                          result.push({
                            titre:
                              "Certificat de signature électronique du contrat de travail",
                            description:
                              "Si le contrat a été signé électroniquement, merci d'ajouter le certificat ou dossier de preuve que vous retrouvez sur votre espace signataire.",
                            type_dossier: id,
                            document_name: "certificat_signature_elec_contrat",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .certificat_signature_elec_contrat
                                .facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .certificat_signature_elec_contrat
                                  .obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .certificat_signature_elec_contrat
                                  .obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .arrete_titularisation.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .arrete_titularisation.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .arrete_titularisation.facultatif_cond
                        )
                          result.push({
                            titre:
                              "Attestation employeur ou arrêté de titularisation",
                            description:
                              "Si attestation, elle doit dater de moins d'un mois",
                            type_dossier: id,
                            document_name: "arrete_titularisation",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .arrete_titularisation.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .arrete_titularisation.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .arrete_titularisation.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .bilans_comptable.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .bilans_comptable.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .bilans_comptable.facultatif_cond
                        )
                          result.push({
                            titre: "2 Derniers bilans comptables",
                            description:
                              "Bilans des années N-1 et N-2 reprenant le chiffre d'affaires et le résultat.",
                            type_dossier: id,
                            document_name: "bilans_comptable",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .bilans_comptable.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .bilans_comptable.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .bilans_comptable.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents.k_bis
                            .obligatoire_cond ||
                          user.dossier.list_garants[id].documents.k_bis
                            .obligatoire_admin ||
                          user.dossier.list_garants[id].documents.k_bis
                            .facultatif_cond
                        )
                          result.push({
                            titre: "Extrait de K-Bis de moins de 3 mois",
                            description:
                              "L'extrait doit dater de moins de 3 mois.",
                            type_dossier: id,
                            document_name: "k_bis",
                            facultatif:
                              user.dossier.list_garants[id].documents.k_bis
                                .facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents.k_bis
                                  .obligatoire_cond ||
                                user.dossier.list_garants[id].documents.k_bis
                                  .obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .declaration_urssaf.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .declaration_urssaf.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .declaration_urssaf.facultatif_cond
                        )
                          result.push({
                            titre: "Déclarations URSSAF",
                            description:
                              "Pour les auto-entrepreneurs, les déclarations URSSAF reprenant le chiffre d'affaire des 2 dernières années.",
                            type_dossier: id,
                            document_name: "declaration_urssaf",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .declaration_urssaf.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .declaration_urssaf.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .declaration_urssaf.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .carte_professionnelle.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .carte_professionnelle.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .carte_professionnelle.facultatif_cond
                        )
                          result.push({
                            titre: "Carte professionnelle",
                            description: "Pour les professions réglementées.",
                            type_dossier: id,
                            document_name: "carte_professionnelle",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .carte_professionnelle.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .carte_professionnelle.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .carte_professionnelle.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .attestation_salaire.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .attestation_salaire.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .attestation_salaire.facultatif_cond
                        )
                          result.push({
                            titre: "Attestation de salaire",
                            description:
                              "S'il y a un versement de salaire, l'attestation comptable reprenant le montant.",
                            type_dossier: id,
                            document_name: "attestation_salaire",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .attestation_salaire.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .attestation_salaire.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .attestation_salaire.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .justificatifs_paiements_retraite
                            .obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .justificatifs_paiements_retraite
                            .obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .justificatifs_paiements_retraite.facultatif_cond
                        )
                          result.push({
                            titre:
                              "3 Derniers justificatifs de paiement de(s) caisse(s) de retraite",
                            description:
                              "Les relevés des 3 derniers mois pour chaque caisse. Les preuves de versement ou relevés bancaires ne sont pas pris en compte.",
                            type_dossier: id,
                            document_name: "justificatifs_paiements_retraite",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .justificatifs_paiements_retraite
                                .facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .justificatifs_paiements_retraite
                                  .obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .justificatifs_paiements_retraite
                                  .obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .ouverture_droit.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .ouverture_droit.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .ouverture_droit.facultatif_cond
                        )
                          result.push({
                            titre: "Document d'ouverture de droit",
                            description:
                              "Le document reprenant les droits pour chaque caisse de retraite.",
                            type_dossier: id,
                            document_name: "ouverture_droit",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .ouverture_droit.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .ouverture_droit.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .ouverture_droit.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .releves_paiement.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .releves_paiement.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .releves_paiement.facultatif_cond
                        )
                          result.push({
                            titre:
                              "3 derniers relevés de versement Pôle Emploi",
                            description:
                              "Documents des 3 derniers mois. Les relevés bancaires ne sont pas pris en compte.",
                            type_dossier: id,
                            document_name: "releves_paiement",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .releves_paiement.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .releves_paiement.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .releves_paiement.obligatoire_admin
                              ),
                          });

                        return result;
                      })(),
                    },
                    {
                      groupIcon: <SavingsIcon fontSize="large"></SavingsIcon>,
                      groupName: "Impôts et revenus",
                      documentsList: (() => {
                        var result = [];

                        if (
                          user.dossier.list_garants[id].documents
                            .avis_imposition.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .avis_imposition.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .avis_imposition.facultatif_cond
                        )
                          result.push({
                            titre:
                              "Deux derniers avis d'imposition (N-1 et N-2) avec toutes les pages ou l'ASDIR",
                            description:
                              "Si rattaché fiscalement, merci de fournir les avis des parents. Pour les personnes non imposables, l'ASDIR (anciennement avis de non-imposition). Pour les ressortissants étrangers, le justificatif fiscal du pays d'origine traduit en français et converti en euros.",
                            type_dossier: id,
                            document_name: "avis_imposition",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .avis_imposition.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .avis_imposition.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .avis_imposition.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .attestation_ratachement.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .attestation_ratachement.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .attestation_ratachement.facultatif_cond
                        )
                          result.push({
                            titre: "Attestation de rattachement fiscal",
                            description: (
                              <>
                                (
                                <a
                                  className="underline"
                                  href={
                                    CONFIG.API_URL +
                                    "/api/attestation_rattachement"
                                  }
                                >
                                  Téléchargeable ici
                                </a>
                                ). Si rattaché sur les deux derniers avis, merci
                                d'indiquer les 2 années d'imposition (et non les
                                années de réception de l'avis).
                              </>
                            ),
                            type_dossier: id,
                            document_name: "attestation_ratachement",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .attestation_ratachement.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .attestation_ratachement.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .attestation_ratachement.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .carte_identite_ratacheur.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .carte_identite_ratacheur.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .carte_identite_ratacheur.facultatif_cond
                        )
                          result.push({
                            titre: "Carte d'identité du/des parents",
                            description:
                              "Si rattaché, merci de fournir la carte ID recto-verso des personnes titulaires de l'avis d'imposition.",
                            type_dossier: id,
                            document_name: "carte_identite_ratacheur",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .carte_identite_ratacheur.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .carte_identite_ratacheur.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .carte_identite_ratacheur.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents
                            .bultins_salaire.obligatoire_cond ||
                          user.dossier.list_garants[id].documents
                            .bultins_salaire.obligatoire_admin ||
                          user.dossier.list_garants[id].documents
                            .bultins_salaire.facultatif_cond
                        )
                          result.push({
                            titre: "3 derniers bulletins de salaire",
                            description:
                              "Si document en plusieurs pages, toutes les pages doivent figurer.",
                            type_dossier: id,
                            document_name: "bultins_salaire",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .bultins_salaire.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .bultins_salaire.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .bultins_salaire.obligatoire_admin
                              ),
                          });

                        if (
                          user.dossier.list_garants[id].documents.livret_famille
                            .obligatoire_cond ||
                          user.dossier.list_garants[id].documents.livret_famille
                            .obligatoire_admin ||
                          user.dossier.list_garants[id].documents.livret_famille
                            .facultatif_cond
                        )
                          result.push({
                            titre: "Livret de famille",
                            description:
                              "L'organisme nous demande ce document afin de prouver le rattachement fiscal ou les enfants à charge. Cf liste des documents Mobili-Pass sur le site Action Logement.",
                            type_dossier: id,
                            document_name: "livret_famille",
                            facultatif:
                              user.dossier.list_garants[id].documents
                                .livret_famille.facultatif_cond &&
                              !(
                                user.dossier.list_garants[id].documents
                                  .livret_famille.obligatoire_cond ||
                                user.dossier.list_garants[id].documents
                                  .livret_famille.obligatoire_admin
                              ),
                          });

                        return result;
                      })(),
                    },
                    {
                      groupIcon: <AddBoxIcon fontSize="large"></AddBoxIcon>,
                      groupName: "Dépôt libre",
                      documentsList: (() => {
                        var result = [];

                        result.push({
                          titre: "Dépôt libre",
                          description: "",
                          type_dossier: id,
                          document_name: "depot_libre",
                          facultatif: true,
                        });

                        return result;
                      })(),
                    },
                  ]}
                />
              </div>
            ))}

            {user.dossier.avec_visale && (
              <div className="divide-y m-6 grid grid-cols-12 gap-x-4 bg-white my-shadow">
                <MetaGroupDocument
                  user={user}
                  setUser={setUser}
                  metaGroupIcon={<FolderIcon fontSize="large"></FolderIcon>}
                  metaGroupName={"Grantie visale"}
                  grantLocataire={"visale"}
                  groupList={[
                    {
                      groupIcon: <PersonIcon fontSize="large"></PersonIcon>,
                      groupName: "Grantie visale",
                      documentsList: (() => {
                        var result = [];

                        if (
                          user.dossier.deuxieme_locataire.documents
                            .piece_identite.obligatoire_cond ||
                          user.dossier.deuxieme_locataire.documents
                            .piece_identite.obligatoire_admin
                        )
                          result.push({
                            titre: "Garantie visale",
                            description:
                              "La garantie VISALE est un plus. Cependant, nous vous conseillons d'avoir également des garants physiques. Certaines agences prendront UNIQUEMENT les garants physiques, d'autres prendront UNIQUEMENT la garantie VISALE. Il est préférable d'avoir les deux afin d'obtenir le plus de propositions de logement possible.",
                            type_dossier: "dossier",
                            document_name: "garantie_visale",
                          });

                        return result;
                      })(),
                    },
                  ]}
                />
              </div>
            )}

            {/* {(user.dossier.avec_deuxieme_locataire || user.dossier.list_garants.length > 0) &&
              <div className='m-6 grid grid-cols-12 gap-x-4'>
                <div className='col-span-12 w-full text-right'>
                  <Button variant='contained' disabled={!(acceptCgu.value && acceptRgpd.value && user.dossier.etat === 'incomplet' && ((user.dossier.avancement_dossier === 1 && (user.dossier.type_contrat !== 'alternance' || user.dossier.list_garants.length > 0)) || (user.dossier.type_contrat !== 'alternance' && user.dossier.avancement_dossier_hors_garant === 1)))}
                    onClick={() => {
                      axios.post(CONFIG.API_URL + '/api/client_soumettre_dossier', { accept_cgu: acceptCgu.value, accept_rgpd: acceptRgpd.value, accept_com: acceptCom.value }, { headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') } })
                        .then((response) => {
                          switch (response.status) {
                            case 200:
                              setUser(response.data);
                              break;

                            default:
                              break;
                          }
                        })
                        .catch((e) => {
                          let response = e.response;

                          if (response === undefined) {
                            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                            return;
                          }

                          switch (response.status) {
                            default:
                              alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
                              break;
                          }
                        });
                    }}
                  >{user.dossier.etat === 'incomplet' ? "Soumettre mon dossier" : "Dossier en cours de vérification"}</Button>
                </div>
              </div>
            } */}
          </div>
        </>
      )}
    </>
  );
}

export default Dossier;
